import {Directive, ElementRef, HostListener, Inject, Input, Renderer2, TemplateRef} from '@angular/core';
import {NgbTooltip, Placement} from "@ng-bootstrap/ng-bootstrap";

@Directive({
  standalone: false,
  selector: '[appBringozTooltip]'
})
export class BringozTooltipDirective {
  @Input('appBringozTooltip') tooltipText!: any | TemplateRef<any>;
  @Input() tooltipDelay: number = 300; // Default delay before showing tooltip
  @Input() tooltipColor: string = 'black'; // Default text color
  @Input() tooltipBgColor: string = 'black'; // Default background color

  @Input() applyHoverColor: boolean = false;
  @Input() hoverColor: string = '#F4F4F4';  // Default background color
  @Input('appTooltipTrigger') tooltip!: NgbTooltip;
  @Input() tooltipPlacement: Placement = 'top';
  @Input() tooltipContainer: 'body' | null = 'body';

  private timeoutId: any;

  constructor(
    @Inject(NgbTooltip) private ngbTooltip: NgbTooltip,
    @Inject(ElementRef) private el: ElementRef,
    @Inject(Renderer2) private renderer: Renderer2
  ) {}


  @HostListener('mouseenter') onMouseEnter() {
    this.ngbTooltip.ngbTooltip = null;
    this.ngbTooltip.close();
    // Set a delay before changing the background
    this.timeoutId = setTimeout(() => {
      // Check if the mouse is still over the element before applying the color
      if (this.el.nativeElement.matches(':hover')) {
        if (!!this.applyHoverColor) {
          this.el.nativeElement.style.backgroundColor = this.hoverColor;
        }
        this.applyTooltipStyles();
        this.ngbTooltip.ngbTooltip = this.tooltipText;
        this.ngbTooltip.placement = this.tooltipPlacement;
        this.ngbTooltip.container = this.tooltipContainer;
        this.ngbTooltip.open();
      }
    }, this.tooltipDelay);
  }

  @HostListener('mouseleave') onMouseLeave() {
    // Clear timeout to prevent background change if the mouse leaves early
    clearTimeout(this.timeoutId);
    if (!!this.applyHoverColor) {
      this.el.nativeElement.style.backgroundColor = ''; // Reset background
    }
    this.ngbTooltip.close();
  }

  private applyTooltipStyles() {
    setTimeout(() => {
      const tooltipElement = document.querySelector('.tooltip-inner'); // NgbTooltip uses this class
      if (tooltipElement) {
        (tooltipElement as HTMLElement).style.backgroundColor = this.tooltipBgColor;
        (tooltipElement as HTMLElement).style.color = this.tooltipColor;
      }
    });
  }
}
